import React, { FunctionComponent } from 'react';
import { PortableText, PortableTextReactComponents } from '@portabletext/react';
import { urlFor } from '../../utils/imageBuilder';
import InternalLink from '../InternalLink';
import InternalLinkV2 from '../InternalLinkV2';
import Table from './Table';
import Accordion from '../Accordion';
import SimpleBlock from './SimpleBlock';
import LinkButton from './LinkButton';
import Video from '../Video';
import './styles.scss';
import Author from './Author';

type RichTextProps = {
  value: any;
}

const components: Partial<PortableTextReactComponents> = {
  types: {
    table: ({ value }) => <Table data={value} />,
    figure: ({ value }) => <img src={urlFor(value).width(650).quality(90).url()} alt={value.alt} />,
    video: ({ value }) => <Video data={value} />,
    linkButton: ({ value }) => <LinkButton data={value} />,
    accordion: ({ value }) => (
      <Accordion
        title={value.title}
        content={value.content}
        open={value.open}
      />
    ),
    author: ({ value }) => <Author data={value} />,
    simpleBlock: ({ value }) => <SimpleBlock data={value} />,
  },
  marks: {
    linkInternal: ({ children, value }) => {
      return <InternalLink reference={value.reference}>{children}</InternalLink>;
    },
    linkInternalV2: ({ children, value }) => {
      console.log('Value:', value);
      return (
        <InternalLinkV2
          reference={value.reference.reference} 
          id={value.reference.id} 
        >
          {children}
        </InternalLinkV2>
      );
    },
    link: ({ value, children }) => {
      const isURL = value.href.startsWith('http');
      const rel = isURL ? 'noreferrer noopener' : '';
      const target = isURL ? '_blank' : '_self';
      return (
        <a href={value.href} target={target} rel={rel}>
          {children}
        </a>
      )
    },
  }
}

const RichText: FunctionComponent<RichTextProps> = ({ value }) => {
  return (
    <div className='rich-text'>
      <PortableText
        value={value}
        components={components}
      />
    </div>
  );
}

export default RichText;
